"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme");

var _Flex = require("../Flex");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VARIANTS = {
  default: {
    backgroundColor: "black10",
    color: "black100"
  },
  info: {
    backgroundColor: "blue10",
    color: "blue100"
  },
  warning: {
    backgroundColor: "copper10",
    color: "copper100"
  },
  error: {
    backgroundColor: "red10",
    color: "red100"
  }
};
var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Message__Container",
  componentId: "t49v7v-0"
})(["", " flex-direction:column;"], (0, _styledSystem.variant)({
  variants: VARIANTS
}));
/** A generic message window for displaying ZerStates, notices, errors, etc. */

var Message = function Message(_ref) {
  var children = _ref.children,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["children", "title"]);

  var size = (0, _Theme.useThemeConfig)({
    v2: "text",
    v3: "sm"
  });
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    p: 2
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: size,
    color: "currentColor"
  }, title), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: size,
    color: "black100"
  }, children));
};

exports.Message = Message;
Message.displayName = "Message";
Message.defaultProps = {
  variant: "default"
};
//# sourceMappingURL=Message.js.map